import { useEffect } from 'react'
import { useCartStore } from './cartStore'

/**
 * Loads the saved basket after the first render (#418). The cart store skips hydration, so the
 * header badge and add-to-basket buttons render exactly what the prerendered HTML holds (an empty
 * basket); this effect then loads the saved basket and those parts update. Mount it as the first
 * child of the app so its effect runs before any page effect.
 */
export default function CartRehydrate() {
  useEffect(() => {
    void useCartStore.persist.rehydrate()
  }, [])
  return null
}
